export default __webpack_public_path__ + "static/assets/be79714ccc3887905dcac4fec5bdf4eb.png";